module.exports = __webpack_public_path__ + "img/sunny.81ece98a.svg";